import { listcate,listcompany3,join, listByUser,host,infoByUserId,joinUser,listcates,expertJoin,join2Usre,companyList } from '@/api/join'


const actions = {
    listcate(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listcate(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listcompany3(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listcompany3(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    join(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            join(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listByUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listByUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    host(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            host(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    infoByUserId(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            infoByUserId(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    joinUser(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            joinUser(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listcates(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listcates(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    expertJoin(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            expertJoin(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    join2Usre(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            join2Usre(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    companyList(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            companyList(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },

}

export default {
  namespaced: true,
  actions
}
